<template>
  <div>
    <div class="filtros">
      <portal to="inputs-grupo-filial">
        <div class="d-flex align-center">
          <SysGrupoAutocomplete
            v-model="filtros.grupos"
            label="Grupos de compras"
            outlined
            dense
            multiple
            class="h-40px w-250"
            ocultar_grupos_todos
            :auto_selecao_grupos="true"
          />
        </div>
      </portal>

      <Filtros
        v-model="filtros"
        @aplicar-filtros="buscarComFiltros()"
      />

    </div>

    <div class="chart">
      <ECharts :dados="dados" />
    </div>

    <div class="tabela mt-n5">
      <Tabela :dados="dados" :filtros="FILTROS_COMPUTED" />
    </div>
  </div>
</template>

<script>
import SysGrupoAutocomplete from '@/components/utils/crud/SysGrupoAutocomplete.vue';
import ECharts from './Chart/Index.vue';
import Tabela from './Tabela/Index.vue';
import { logout } from "@/helpers";
import { iniciarDadosGrafico } from '@/api/Indicadores/StatusProdutoV3';
import Filtros from './Filtros/Index';

export default {
  components: { SysGrupoAutocomplete, Filtros, ECharts, Tabela },
  data: () => ({
    dados: [],
    filtros: {
      grupos: [],
      segmentos: [],
      fornecedores: [],
      compradores: [],
      classificacao_financeira: [],
      classificacao_criticidade: [],
      classificacao_comprabilidade: [],
      classificacao_popularidade: [],
      classificacao_rentabilidade: []
    },
  }),
  created() {
    this.filtros.grupos = [this.$store.getters['usuario/getGrupoCompras']];
  },
  watch: {
    "filtros.grupos"() {
      this.buscarComFiltros();
    }
  },
  computed: {
    FILTROS_COMPUTED() {
      return {
        ...this.$store.getters['filtrosProdutosDiagnostico/filtros_formato_api'],
        ...this.filtros,
      }
    }
  },
  methods: {
    buscarComFiltros() {
      this.buscarDadosGrafico();
    },
    buscarDadosGrafico() {
      this.$store.dispatch(
        "loading/addRequisicao",
        iniciarDadosGrafico(this.FILTROS_COMPUTED)
          .then(detalhes => this.dados = detalhes)
          .catch(logout)
      );
    },
  }
}
</script>

<style scoped>
.filtros {}
.chart {
  height: calc(100vh - 265px) !important;
}
.tabela {}
</style>
